module.exports = __webpack_public_path__ + "img/Home_Hintergrund.56f58a5b.jpg";